// Simulation timestamps arrive in milliseconds but are presented in seconds.

// Drop binary floating point noise from the division, e.g. trailing ...0000001.
const clean = (value: number): number => Number(value.toPrecision(12));

export const msToSeconds = (ms: number): number => clean(ms / 1000);
